// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILinkedApplicationUserResponseDto
 */
export interface ILinkedApplicationUserResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ILinkedApplicationUserResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILinkedApplicationUserResponseDto
     */
    username?: string;
    /**
     * 
     * @type {Date}
     * @memberof ILinkedApplicationUserResponseDto
     */
    last_password_update?: Date;
    /**
     * 
     * @type {string}
     * @memberof ILinkedApplicationUserResponseDto
     */
    role?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ILinkedApplicationUserResponseDto
     */
    is_locked_by_admin?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ILinkedApplicationUserResponseDto
     */
    mfa_locked_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ILinkedApplicationUserResponseDto
     */
    mfa_locked_to?: Date;
}

/**
 * Check if a given object implements the ILinkedApplicationUserResponseDto interface.
 */
export function instanceOfILinkedApplicationUserResponseDto(value: object): value is ILinkedApplicationUserResponseDto {
    return true;
}

export function ILinkedApplicationUserResponseDtoFromJSON(json: any): ILinkedApplicationUserResponseDto {
    return ILinkedApplicationUserResponseDtoFromJSONTyped(json, false);
}

export function ILinkedApplicationUserResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILinkedApplicationUserResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'username': json['username'] == null ? undefined : json['username'],
        'last_password_update': json['last_password_update'] == null ? undefined : (new Date(json['last_password_update'])),
        'role': json['role'] == null ? undefined : json['role'],
        'is_locked_by_admin': json['is_locked_by_admin'] == null ? undefined : json['is_locked_by_admin'],
        'mfa_locked_at': json['mfa_locked_at'] == null ? undefined : (new Date(json['mfa_locked_at'])),
        'mfa_locked_to': json['mfa_locked_to'] == null ? undefined : (new Date(json['mfa_locked_to'])),
    };
}

export function ILinkedApplicationUserResponseDtoToJSON(json: any): ILinkedApplicationUserResponseDto {
    return ILinkedApplicationUserResponseDtoToJSONTyped(json, false);
}

export function ILinkedApplicationUserResponseDtoToJSONTyped(value?: ILinkedApplicationUserResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'username': value['username'],
        'last_password_update': value['last_password_update'] == null ? undefined : ((value['last_password_update']).toISOString()),
        'role': value['role'],
        'is_locked_by_admin': value['is_locked_by_admin'],
        'mfa_locked_at': value['mfa_locked_at'] == null ? undefined : ((value['mfa_locked_at']).toISOString()),
        'mfa_locked_to': value['mfa_locked_to'] == null ? undefined : ((value['mfa_locked_to']).toISOString()),
    };
}

